export enum DataType {
	Address = 'address',
	Boolean = 'boolean',
	Email = 'email',
	Number = 'number',
	Phone = 'phone',
	Text = 'text',
	Website = 'website'
}
